'use client';

import ErrorComponent from '@/components/ErrorComponent';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <html>
      <body>
        <ErrorComponent error={error} context='global-error' />
      </body>
    </html>
  );
}
